import { Component, OnInit } from '@angular/core';
import { DomainBrandService, SeoService } from '@services/index';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  urlContact!: string;

  constructor(
    private _domainBrand: DomainBrandService,
    private _seo: SeoService
  ) {}

  ngOnInit(): void {
    const hashtag = `#`;
    this.urlContact = `./home${hashtag}scrollcontacts`;
    this._seo.setPageMeta({
      title: `Página no encontrada | ${this._domainBrand.documentTitle}`,
    });
  }
}
